module.exports = __webpack_public_path__ + "79354e72ad0559ef82e28d0f2e88033f.svg";